import { uniqueId } from 'lodash';

import {
  IconAperture,
  IconUsersGroup,
  IconSettingsAutomation,
  IconGiftCard,
  IconUserCircle,
  IconCashBanknote,
  IconSteeringWheel,
  IconRobot,
  IconPhone,
  IconList,
  IconFilePlus,
  IconWheel,
  IconMoneybag,
  IconLayoutDashboard,
  IconUserPlus,
  IconAffiliate,
  IconRefresh,
  IconSettings,
  IconDeviceGamepad2,
  IconTrendingUp,
  IconCash,
  IconChartLine,
  IconCoinBitcoin,
  IconUserShare,
  IconChartBar,
  IconBrandTelegram,
  IconMailPlus,
  IconHistory,
  IconUsers,
  IconAward,
  IconRewindForward50,
  IconSettingsCog,
  IconAdjustments
} from '@tabler/icons-react';
import { IconReportMoney } from '@tabler/icons';
import { IconMailBolt } from '@tabler/icons-react';
import { ENUM_STRING_MENU } from './enums';

export const ENUM_MENU_TYPE = {
  retentionGroup: 'retentionGroup'
};

export const ENUM_BONUS_ID = {
  promocode: 'promocode',
  jackpots: 'jackpots',
  welcome: 'welcome',
  cashback: 'cashback',
  freespin: 'freespin',
  launch_bot: 'launch_bot',
  phone_bot: 'phone_bot'
};

export const bonusInfoById = {
  [ENUM_BONUS_ID.promocode]: { label: 'Promocode', icon: IconGiftCard },
  [ENUM_BONUS_ID.welcome]: { label: 'Welcome', icon: IconUserCircle },
  [ENUM_BONUS_ID.cashback]: { label: 'Cashback', icon: IconCashBanknote },
  [ENUM_BONUS_ID.freespin]: { label: 'Freespin', icon: IconSteeringWheel },
  [ENUM_BONUS_ID.launch_bot]: { label: 'Launching a bot', icon: IconRobot },
  [ENUM_BONUS_ID.phone_bot]: { label: 'Phone in the bot', icon: IconPhone },
  [ENUM_BONUS_ID.jackpots]: { label: 'Jackpots', icon: IconReportMoney }
};

export const disabledBonusTab = (isNodeGroup, tabId) =>
  isNodeGroup &&
  [
    ENUM_BONUS_ID.jackpots,
    ENUM_BONUS_ID.freespin,
    ENUM_BONUS_ID.launch_bot,
    ENUM_BONUS_ID.phone_bot
  ].includes(tabId);

export const getRetentionGroupChildren = (groupId, isGame) => {
  const getChildrenBonus = () => {
    let bonuses = [];
    for (let bonusId in ENUM_BONUS_ID) {
      const bonusInfo = bonusInfoById[bonusId];
      const isDisable = disabledBonusTab(!isGame, bonusId);
      if (isDisable) continue;

      bonuses.push({
        id: uniqueId(),
        title: bonusInfo.label,
        icon: bonusInfo.icon,
        href: `/bonuses/${bonusId}/${groupId}`
      });
    }

    return bonuses;
  };

  const data = [
    {
      id: uniqueId(),
      title: 'Bonuses',
      icon: IconMoneybag,
      chipColor: 'error.main',
      children: getChildrenBonus()
    },
    {
      id: uniqueId(),
      title: 'Freespins templates',
      icon: IconWheel,
      chipColor: 'purple.A200',
      children: [
        {
          id: uniqueId(),
          title: 'List of templates',
          icon: IconList,
          href: `/freespin/${groupId}/list`
        },
        {
          id: uniqueId(),
          title: 'Add new template',
          icon: IconFilePlus,
          href: `/freespin/${groupId}/new`
        }
      ]
    }
  ];

  if (isGame) {
    data.unshift({
      id: uniqueId(),
      title: 'Affiliate links',
      icon: IconAffiliate,
      chipColor: 'primary.main',
      children: [
        {
          id: uniqueId(),
          title: 'Referral links',
          icon: IconUserPlus,
          href: `/affiliate/${groupId}/referral`
        },
        {
          id: uniqueId(),
          title: 'Postbacks',
          icon: IconRefresh,
          href: `/affiliate/${groupId}/postbacks`
        }
      ]
    });
  }

  if (!isGame) {
    data.push({
      id: uniqueId(),
      title: 'Slider banners',
      icon: IconLayoutDashboard,
      children: [
        {
          id: uniqueId(),
          title: 'List of banners',
          icon: IconList,
          href: `/slider-banners/${groupId}/list`
        },
        {
          id: uniqueId(),
          title: 'Add new banner',
          icon: IconFilePlus,
          href: `/slider-banners/${groupId}/new`
        }
      ]
    });
  }

  // data.push({
  //   id: uniqueId(),
  //   title: 'Users',
  //   icon: IconUsersGroup,
  //   href: `/users/list?groupId=${groupId}`
  // });

  return data;
};

const Menuitems = [
  {
    id: uniqueId(),
    title: 'Dashboard',
    icon: IconAperture,
    href: '/dashboard',
    chipColor: 'secondary'
  },
  {
    id: uniqueId(),
    title: 'Groups',
    icon: IconUsersGroup,
    href: '/groups',
    chipColor: 'secondary'
  },
  {
    id: uniqueId(),
    title: '',
    type: ENUM_MENU_TYPE.retentionGroup,
    icon: IconUsersGroup,
    noTransition: true
  },
  {
    id: uniqueId(),
    title: 'Users',
    icon: IconUserShare,
    href: `/users/list/`
  },
  {
    id: uniqueId(),
    title: 'Telegram mailings',
    icon: IconBrandTelegram,
    children: [
      {
        id: uniqueId(),
        title: 'Scheduler',
        icon: IconMailBolt,
        href: `/mailing/scheduler`
      },
      {
        id: uniqueId(),
        title: 'Create a mailing',
        icon: IconMailPlus,
        href: `/mailing/new`
      },
      {
        id: uniqueId(),
        title: 'Mailing history',
        icon: IconHistory,
        href: `/mailing/history`
      }
    ]
  },
  {
    id: uniqueId(),
    title: 'Finance',
    href: '/finance',
    icon: IconChartLine,
    isHorizontalOther: true,
    children: [
      {
        id: uniqueId(),
        title: 'Player deposits',
        icon: IconCashBanknote,
        href: `/finance/players/deposits`
      },
      {
        id: uniqueId(),
        title: 'Payments to players',
        icon: IconCash,
        href: `/finance/players/payments`
      },
      {
        id: uniqueId(),
        title: 'Crypto gateway balance',
        icon: IconCoinBitcoin,
        href: `/finance/balance/gateway`
      }
    ]
  },
  {
    id: uniqueId(),
    title: 'Reports',
    icon: IconChartBar,
    isHorizontalOther: true,
    children: [
      {
        id: uniqueId(),
        title: 'Player reports',
        icon: IconUsers,
        href: `/reports/players`
      },
      {
        id: uniqueId(),
        title: 'Bonus reports',
        icon: IconAward,
        href: `/reports/bonuses`
      },
      {
        id: uniqueId(),
        title: 'Refcode reports',
        icon: IconUserShare,
        href: `/reports/refcode/`
      },
      {
        id: uniqueId(),
        title: 'Game statistics',
        icon: IconTrendingUp,
        href: `/reports/games/statistic`
      }
    ]
  },
  {
    id: uniqueId(),
    title: 'Game providers',
    icon: IconDeviceGamepad2,
    href: `/settings/games/providers`,
    isHorizontalOther: true
  },
  {
    id: uniqueId(),
    stringId: ENUM_STRING_MENU.casinoSetting,
    title: 'Casino settings',
    icon: IconSettings,
    chipColor: 'secondary',
    href: `/settings/casino`,
    isHorizontalOther: true
  },
  {
    id: uniqueId(),
    stringId: ENUM_STRING_MENU.gambitAggregator,
    title: 'Provider settings',
    icon: IconAdjustments,
    chipColor: 'secondary',
    href: `/settings/providers`,
    isHorizontalOther: true
  }
];

export default Menuitems;
